<template>
  <div class="tops" >
      <div class="head w120">
          <img src="@/assets/logo.png" alt="">
          <div class="head_txt">
            <router-link to="/" :class="active=='1'?'active':''"> 
              <span>首页</span>
              <img src="@/assets/nav.png" alt="" v-if="active==1">
            </router-link>
            <router-link to="/software" :class="active=='2'?'active':''" @mouseover.native="moverClick">
              <span>解决方案</span>
              <img src="@/assets/nav.png" alt=""  v-if="active==2">
              <div class="show_mask"  ref="showMaks">
                <router-link to="/software" :class="link=='1'?'active':''" @mouseleave.native="moverLeaveOut" @mouseover.native="moverC">
                  软件介绍
                  <div ref="linkOne">
                    <router-link to="/programme" :class="link=='3'?'active':''">滑雪场解决方案</router-link>
                    <router-link to="/scenic" :class="link=='4'?'active':''">景区解决方案</router-link>
                  </div>
                </router-link>
                <router-link to="/hardware" :class="link=='2'?'active':''" @mouseleave.native="moverLeaveOu" @mouseover.native="moverCli">硬件设备
                  <div  ref="linkTwo">
                    <router-link to="/programme" :class="link=='3'?'active':''">滑雪场解决方案</router-link>
                    <router-link to="/scenic" :class="link=='4'?'active':''">景区解决方案</router-link>
                  </div>
                </router-link>
              </div>
            </router-link>
            <router-link to="/customer" :class="active=='3'?'active':''">
              <span>客户案例</span>
              <img src="@/assets/nav.png" alt=""  v-if="active==3">
            </router-link>
            <router-link to="/problem" :class="active=='4'?'active':''">
              <span>常见问题</span>
              <img src="@/assets/nav.png" alt=""  v-if="active==4">
            </router-link>
            <router-link to="/Third" :class="active=='5'?'active':''">
              <span>资源中心</span>
              <img src="@/assets/nav.png" alt=""  v-if="active==5">
            </router-link>
            <router-link to="/about" :class="active=='6'?'active':''">
              <span>关于我们</span>
              <img src="@/assets/nav.png" alt=""  v-if="active==6">
            </router-link>
            <div class="Vector" @mouseover="moverClicks" >
              <img src="@/assets/Vector.png" alt="">
              <div class="show_masks"  ref="phone" >
                <div ref="linkOness" @mouseout="moverLeaveOutss">
                  <div>+86 18611793381</div>
                  <div>+86 15611477385</div> 
                  <div>+86 13021175339</div>  
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props:['active','link'],
  data(){
    return{
      
    }
  },
  created(){
  },
  methods:{
    moverLeaveOutss(){
      console.log(321)
      this.$refs.phone.style.display = "none"
      this.$refs.linkOness.style.display = "none"
    },
    moverClicks(){
      this.$refs.phone.style.display = "block"
      this.$refs.linkOness.style.display = "block"

    },
    moverClick(){
      this.$refs.showMaks.style.display = "block"
    },
    moverC(){
      this.$refs.linkTwo.style.display = "none"
      this.$refs.linkOne.style.display = "block"
    },
    moverCli(){
      this.$refs.linkOne.style.display = "none"
      this.$refs.linkTwo.style.display = "block"
    },
    moverLeaveOut(){
      this.$refs.linkTwo.style.display = "none"
      this.$refs.linkOne.style.display = "none"
      this.$refs.showMaks.style.display = "none"
    },
    moverLeaveOu(){
      this.$refs.showMaks.style.display = "none"
      this.$refs.linkTwo.style.display = "none"
      this.$refs.linkOne.style.display = "none"
    }
  }
}
</script>
<style scoped lang="less">
.tops{
  width:100%;
  background: rgba(0, 30, 60, 0.6);
  height: 7.2rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  .head{
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    >img{
      width: 19.8rem;
      height: 3.1rem;
    }
  }
  .head_txt{
    display: flex;
    height: 100%;
    align-items: center;
    >a{
      height: 100%;
      margin-left: 4rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      &:hover{
         span{
            color: #FCC62C !important;
         }
      }
      >span{
        color: #FFFFFF;
        font-size: 1.6rem;
      }
      .show_mask{
        position: absolute;
        bottom: -13rem;
        left: 0;
        display: none;
        >a{
          width: 18.6rem;
          height: 6rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0,30,60, 0.6);
          border-radius: 0.8rem;
          color: #FFFFFF;
          font-size: 1.6rem;
          margin-bottom: 0.2rem;
          position: relative;
          >div{
            position: absolute;
            top: 0;
            display: none;
            left: 18.8rem;
            >a{
              width: 18.6rem;
              height: 6rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(0,30,60, 0.6);
              border-radius: 0.8rem;
              color: #FFFFFF;
              font-size: 1.6rem;
              margin-bottom: 0.2rem;
            }
          }
        }
      }
    }
    .active{
      position: relative;
        >span{
          color: #FCC62C;
        }  
        img{
          position: absolute;
          width: 1.87rem;
          height: 0.66rem;
          bottom: 0.5rem;
          left: 50%;
          transform: translate(-50%,0);
        }
    }
    >img{
      width: 2.5rem;
      height: 1.6rem;
      margin-left: 4rem;
      cursor: pointer;
    }
  }
}
.active{
  color: #FCC62C !important;
}
.Vector{
  margin-left: 4.2rem;
  position: relative;
  img{
    width: 2rem;
    height: 1.8rem;
    cursor: pointer;
  }
  .show_masks{
    position: absolute;
    left: -15rem;
    margin-top: 2rem;
    display: none;
    >div{
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0,30,60, 0.6);
      border-radius: 0.8rem;
      color: #FFFFFF;
      font-size: 1.6rem;
      margin-bottom: 0.2rem;
      display: flex;
      flex-direction: column;
      >div{
          width: 18.6rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0,30,60, 0.6);
          border-radius: 0.8rem;
          color: #FFFFFF;
          font-size: 1.6rem;
          margin-bottom: 0.2rem;
          padding: 2rem 0;
          box-sizing: border-box;
      }
    }
  }
}
</style>